import React from "react";
import LegalPage, { LegalSection } from "../components/LegalPage";

export default function SellerTerms() {
  return (
    <LegalPage
      title="판매자 이용약관"
      description="서버 카드 크리에이터의 판매, 환불 및 정산 조건입니다. 약관 버전 2026-08-03-v2"
      effectiveDate="2026년 8월 3일"
    >
      <LegalSection title="제1조 판매자 등록">
        <p>판매자는 개인 또는 사업자 유형을 선택하고 실명, 연락처, 주소, 정산 계좌 등 정확한 정보를 등록해야 합니다. 사업자는 상호와 사업자등록번호를 추가로 입력해야 하며, 사업자에 해당하면서 개인 판매자로 표시해서는 안 됩니다.</p>
        <p>판매자는 만 19세 이상이거나 판매 및 정산 계약을 체결할 적법한 권한이 있어야 합니다. 회사는 본인확인, 계좌 확인, 사업자 확인을 요청할 수 있고 확인되지 않은 경우 판매 또는 정산을 제한할 수 있습니다.</p>
      </LegalSection>
      <LegalSection title="제2조 상품 등록과 심사">
        <p>판매자 등록은 즉시 완료되지만 각 서버 카드 상품은 회사의 심사를 거쳐 승인된 후 판매됩니다. 판매자는 상품을 직접 제작했거나 판매에 필요한 권리를 보유해야 하며, 타인의 저작권·상표권·초상권·개인정보를 침해해서는 안 됩니다.</p>
        <p>회사는 불법·유해 콘텐츠, 권리 침해, 오인 가능성이 있는 설명, 작동하지 않는 상품 또는 운영 정책에 맞지 않는 상품을 반려·숨김·삭제할 수 있으며 그 사유를 안내합니다.</p>
      </LegalSection>
      <LegalSection title="제3조 거래 당사자와 회사의 역할">
        <p>크리에이터 상품의 판매자는 해당 크리에이터이고 구매자는 상품을 주문한 이용자입니다. 회사는 통신판매중개자로서 상품 노출, 주문 접수, 결제, 환불 접수, 거래 기록 및 분쟁 처리 기능을 제공합니다.</p>
        <p>판매자는 구매자에게 표시되어야 하는 판매자 정보와 거래 조건을 회사가 상품 화면에 표시하는 데 동의합니다. 개인 판매자의 주소·전화번호 등 비공개 신원 정보는 일반 공개하지 않으며 분쟁 해결 또는 법령상 요청에 필요한 경우에만 제공합니다.</p>
      </LegalSection>
      <LegalSection title="제4조 판매 수수료와 정산금">
        <p>판매 수수료는 결제 금액의 30%이고 판매자 적립액은 결제 금액의 70%입니다. 환불, 결제 취소, 부정 결제, 세금 및 법령상 공제 사유가 있으면 정산 가능 금액에서 조정될 수 있습니다.</p>
        <p>판매 금액은 구매일로부터 7일 동안 환불 보류 상태로 유지된 뒤 정산 가능 금액으로 전환됩니다. 정산 가능 금액이 50,000원 이상일 때 전액 지급을 요청할 수 있습니다.</p>
      </LegalSection>
      <LegalSection title="제5조 지급 시기와 계좌">
        <p>정산 요청은 등록된 본인 명의 계좌로 처리됩니다. 운영자 확인이 완료된 뒤 원칙적으로 최대 1시간 이내 이체하지만, 금융기관 점검·장애, 계좌 정보 오류, 본인확인, 이상 거래 조사, 공휴일 또는 불가항력 사유가 있으면 지연될 수 있습니다. 지연 사유와 예상 처리 일정을 안내합니다.</p>
        <p>판매자는 계좌와 세무 정보를 최신 상태로 유지해야 합니다. 잘못된 정보로 인한 반환 수수료나 지연은 판매자에게 귀속될 수 있습니다.</p>
      </LegalSection>
      <LegalSection title="제6조 환불과 정산 조정">
        <p>구매자의 적법한 청약철회, 상품 하자, 표시 내용과의 불일치 또는 결제 취소가 발생하면 해당 판매 금액은 적립 취소 또는 차감됩니다. 이미 지급된 뒤 환불이 확정된 경우 회사는 다음 정산금에서 공제하거나 판매자에게 반환을 요청할 수 있습니다.</p>
        <p>판매자는 환불 및 분쟁 처리에 필요한 상품 파일, 설명, 공급 기록을 제공하고 회사의 사실 확인에 협조해야 합니다.</p>
      </LegalSection>
      <LegalSection title="제7조 세금과 자료 보관">
        <p>판매 수익에 관한 신고와 납부 의무는 판매자에게 있습니다. 회사는 법령에 따라 판매·정산 자료를 과세관청 등 관계 기관에 제출하거나 세금계산서·지급 관련 자료를 요청할 수 있습니다.</p>
        <p>계약·결제·공급·환불·정산 기록은 전자상거래 관련 법령이 정한 기간 동안 보관됩니다.</p>
      </LegalSection>
      <LegalSection title="제8조 이용 제한과 계약 종료">
        <p>허위 정보, 권리 침해, 부정 결제 가담, 반복적인 환불 유발, 법령 위반이 확인되면 상품 판매와 정산을 제한할 수 있습니다. 긴급한 피해 방지를 위한 경우를 제외하고 제한 사유와 소명 방법을 안내합니다.</p>
        <p>계약이 종료되어도 종료 전에 발생한 주문, 환불, 정산, 분쟁 및 자료 보관 의무에는 이 약관이 계속 적용됩니다.</p>
      </LegalSection>
      <LegalSection title="제9조 변경과 문의">
        <p>수수료, 정산 기준 등 중요한 조건을 변경할 때에는 원칙적으로 30일 전에 알리고 필요한 경우 다시 동의를 받습니다. 변경 전 완료된 거래에는 주문 당시 조건을 적용합니다.</p>
        <p>판매 및 정산 문의: inhyuk0078@gmail.com · 010-9174-6988</p>
      </LegalSection>
    </LegalPage>
  );
}
